import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=28c44786&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c44786",
  null
  
)

export default component.exports